export default __webpack_public_path__ + "static/media/icon_nps.fae631d7.svg";